module.exports = __webpack_public_path__ + "static/media/Moe Zun.83306155.png";